import * as React from 'react';
import Button from '@mui/material/Button';
import Snackbar, { SnackbarCloseReason } from '@mui/material/Snackbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Stack from '@mui/material/Stack';
import AlertTitle from '@mui/material/AlertTitle';
import Alert from '@mui/material/Alert';
export default function Mysnackbar({open,maasge}) {//{open}props
//   const [open, setOpen] = React.useState(true);لانه عيمثل التطبيق كتمل نشتيapp.jsنشلها ل

  const action = (
    <React.Fragment>
      
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
       
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </React.Fragment>
  );

  return (
    <div>
     <Stack sx={{ width: '100%' }} spacing={2}>          
         
      <Snackbar
        open={open}
        autoHideDuration={6000}
       
        message="Note archived"
        action={action}
        >
        <Alert
       
         severity="success">
        
        {/* This is a success Alert with an encouraging title. */}
        {maasge}
      </Alert>      
      </Snackbar>   
      </Stack>
    </div>
  );
}